import { ENV } from "@/core/config/env";
import routeTenant from "@/core/services/routeTenant.service"

const baseUrlTenant = routeTenant.routeBaseConfig();

const notification = [
    {
        path: baseUrlTenant,
        name: "notification",
        component: () => import("@/view/layout/Layout"),
        children: [
            {
                path: "notification-create",
                name: "notification-create",
                component: () => import("@/view/pages/notification/Create")

            },
            {
                path: "notification-edit",
                name: "notification-edit",
                component: () => import("@/view/pages/notification/Edit")

            },
            {
                path: "notification-list",
                name: "notification-list",
                component: () => import("@/view/pages/notification/List")

            }
        ]
    },
]

export default notification
